import { NgClass, NgIf } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'kb-quantity-input',
    templateUrl: './quantity-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuantityInputComponent),
            multi: true,
        },
    ],
    standalone: true,
    imports: [FormsModule, NgIf, FaIconComponent, NgClass],
})
export class QuantityInputComponent implements ControlValueAccessor {
    @Input() max = 10000;
    @Input() min = 0;
    @Input() placeholder = '0';

    @Input() label?: string;
    @Input() hideButtons: boolean;

    value = 0;
    onChange: (value: number) => void;
    onTouched: () => void;
    disabled = false;

    readonly iconMinus = faMinus;
    readonly iconPlus = faPlus;

    writeValue(value: number): void {
        this.value = value;
    }

    registerOnChange(fn: (value: number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Handle the disabled state if needed
        this.disabled = isDisabled;
    }

    updateValue(value: number): void {
        this.value = Math.min(this.max, Math.max(this.min, value));
        this.onChange?.(this.value);
        this.onTouched?.();
    }

    decrement() {
        this.updateValue(this.value - 1);
    }

    increment() {
        this.updateValue(this.value + 1);
    }
}
